<template>
  <div>
    <Header></Header>
    <div class="textContent">
      <p class="title">Terms of Use</p>
      <p class="text">Eleven11 Community Guidelines</p>
      <p class="text">When you use Eleven11, you join a global community of sports fans. Every user of Eleven11 follows a standard of civilized and high-quality communication, and we trust you to do the same. Adhering to the guidelines below helps keep Eleven11 enjoyable for everyone.</p>
      <p class="text">Here are some common-sense rules to help you avoid trouble. Please take these rules seriously and embrace the spirit in which they were created.</p>

      <p class="title2">1. HARMFUL OR DANGEROUS SPEECH</p>
      <p class="text">Do not post speech that encourages others, especially children, to engage in activities that could result in serious injury. Speech promoting harmful or dangerous actions may be age-restricted or removed, depending on its severity.</p>

      <p class="title2">2. HATEFUL SPEECH</p>
      <p class="text">Our products are platforms for free expression. However, we do not support speech that promotes or condones violence against individuals or groups based on race, ethnic origin, religion, disability, gender, age, nationality, veteran status, caste, sexual orientation, or gender identity. Additionally, we do not support speech that incites hatred based on these core characteristics.</p>

      <p class="title2">3. HARASSMENT AND CYBERBULLYING</p>
      <p class="text">It’s not ok to post abusive speech and comments on Eleven11. If harassment crosses the line into a malicious attack it can be reported and may be removed. In other cases, users may be mildly annoying or petty and should be ignored.</p>

      <p class="title2">4. THREATS</p>
      <p class="text">Things like predatory behavior, stalking, threats, harassment, intimidation, invading privacy, revealing other people's personal information, and inciting others to commit violent acts or to violate the Terms of Use are taken very seriously. Anyone caught doing these things may be permanently banned from Eleven11.</p>

      <p class="title2">5. ACCESS FOR CHILDR</p>
      <p class="text">Learn about how we protect minors in the Eleven11 ecosystem. We work closely with law enforcement and report any instances of child endangerment.</p>
      <p class="text">You might not like everything you see on Eleven11. If you encounter inappropriate content, use the reporting feature to submit it for review by our Eleven11 staff. Our team carefully reviews flagged content 24/7 to determine if there is a violation of our Community Guidelines.</p>
      <p class="text">If an Eleven11 user seriously violates the regulations, we may respond based on various factors, including the severity of their actions and whether a pattern of harmful behavior exists. Our responses range from restricting the user's ability to speak to terminating their account.</p>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
export default {
  name: "TermsOfUse",
  components: {
    Header,
  },
  metaInfo: {
    title: "Eleven11 - Terms of Use",
    meta: [
      {
        name: "description",
        content:
          "Eleven11, Terms of Use.",
      },
      {
        name: "keywords",
        content:"terms of use"
      }
    ]
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.textContent {
  width: 976px;
  height: 100%;
  margin: 0 auto;
  font-family: PingFangSC, PingFang SC;
  color: #242424;
  .title{
    font-weight: bold;
    font-size: 18px;
    margin-top: 24px;
  }
  .title2{
    font-size: 14px;
    font-weight: 500;
    margin-top: 24px;
  }
  .text{
    font-size: 12px;
    font-weight: 400;
    margin-top: 14px;
  }
}
</style>
